import React, { memo, useEffect, useMemo, useState } from "react";
import { Table } from "antd";

import useFetch from "../../hooks/useFetch";
import { TENANT_TABLE_COLUMNS } from "../../const";
import { ITenantDisplay } from "../AddTenant/types";
import { url } from "../../http";

import Spinner from "../../common/Spinner";
import ListPageHeader from "../../components/ListPageHeader";

import "./style.scss";

const Tenants: React.FC = () => {
  const { data, isLoading } = useFetch<
    {
      name: string;
      last_modified: string;
      plugins_number: number;
      policies_number: number;
    }[]
  >(`${url}/v1/tenants`);

  const [tenants, setTenants] = useState<ITenantDisplay[]>([]);

  useEffect(() => {
    if (data) {
      setTenants(
        data.map(item => ({
          name: item.name,
          plugins: item.plugins_number,
          policies: item.policies_number,
          lastUpdated: item.last_modified,
        })),
      );
    }
  }, [data]);

  const [search, setSearch] = useState("");

  const [searchedTenants, setSearchedTenants] = useState<ITenantDisplay[]>([]);

  useEffect(
    () =>
      setSearchedTenants(
        tenants.filter(item =>
          item.name.toLowerCase().includes(search.toLowerCase()),
        ),
      ),
    [search, tenants],
  );

  const generatedTenants = useMemo(
    () =>
      searchedTenants.map(item => ({
        key: item.name,
        name: item.name,
        plugins: item.plugins,
        policies: item.policies,
        lastUpdated: item.lastUpdated.replace(
          /^(\d+)\-(\d+)\-(\d+)\D.+$/,
          "$3.$2.$1",
        ),
      })),
    [searchedTenants],
  );

  return (
    <div className="tenants-list">
      <ListPageHeader setSearchItems={setSearch} />
      <div className="tenants-table">
        {isLoading ? (
          <Spinner />
        ) : (
          <>
            <Table
              dataSource={generatedTenants}
              columns={TENANT_TABLE_COLUMNS}
              pagination={{
                pageSize: 5,
                pageSizeOptions: [5, 10],
              }}
              className="table"
            />
          </>
        )}
      </div>
    </div>
  );
};

export default memo(Tenants);
